import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { OperatorPermissions, PermissionArea, PermissionLevel } from '../auth/operator-permissions.service';
import { firstPermittedPath } from '../../shared/layout/nav-items';

/** Matches the route only when the operator holds the area permission; otherwise sends them to the first page they may view. */
export function requirePermission(area: PermissionArea, level: PermissionLevel = 'view'): CanMatchFn {
  return async () => {
    const perms = inject(OperatorPermissions);
    const router = inject(Router);
    await perms.ensureLoaded();
    if (perms.allows(area, level)) return true;
    return router.parseUrl(firstPermittedPath(perms) ?? '/');
  };
}

/** The empty path: redirects to the first permitted page; matches (rendering the no-access page) when there is none. */
export const landingGuard: CanMatchFn = async () => {
  const perms = inject(OperatorPermissions);
  const router = inject(Router);
  await perms.ensureLoaded();
  const path = firstPermittedPath(perms);
  return path ? router.parseUrl(path) : true;
};
